// src/pages/CarHire.tsx
import React, { useState } from "react";
import InquiryModal from "../components/InquiryModal";
import carhire from "../assets/images/car-hire.jpg"

const CarHire: React.FC = () => {
  const [showInquiry, setShowInquiry] = useState(false);
const [inquiryData, setInquiryData] = useState({
    type: "Hotel" as const, // use one of "Flight" | "Hotel" | "Package" | "Insurance"
    from: "",
    to: "",
    date: "",
    name: "",
    email: "",
    phone: "",
  });

  const carInfo = {
    title: "Car Hire",
    description:
      "Rent cars at your destination with ease. Our car hire services offer a variety of vehicles, from compact cars to luxury SUVs.",
    features: [
      "Flexible rental duration",
      "Airport pickup available",
      "Insurance options included",
      "24/7 customer support",
    ],
  };

  return (
    <div
      style={{
        padding: "3rem 2rem",
        maxWidth: "900px",
        margin: "0 auto",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: "#333",
      }}
    >
      {/* Hero Section */}
      <div
        style={{
          backgroundImage: `url(${carhire})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "12px",
          padding: "5rem 2rem",
          color: "#fff",
          textAlign: "center",
          marginBottom: "2rem",
          boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
        }}
      >
        <h1 style={{ fontSize: "3rem", fontWeight: 700 }}>{carInfo.title}</h1>
        <p style={{ fontSize: "1.25rem", marginTop: "1rem" }}>
          {carInfo.description}
        </p>
      </div>

      {/* Features */}
      <div style={{ marginBottom: "2rem" }}>
        <h2 style={{ fontSize: "2rem", marginBottom: "1rem" }}>Features</h2>
        <ul style={{ paddingLeft: "1.2rem", lineHeight: 1.8 }}>
          {carInfo.features.map((feature, idx) => (
            <li key={idx}>{feature}</li>
          ))}
        </ul>
      </div>

      {/* Inquiry Button */}
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <button
          onClick={() => setShowInquiry(true)}
          style={{
            padding: "0.8rem 2rem",
            backgroundColor: "#E1306C",
            color: "#fff",
            borderRadius: "6px",
            border: "none",
            fontWeight: "bold",
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            transition: "transform 0.3s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
          onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          Send Inquiry
        </button>
      </div>

     {/* Inquiry Modal */}
      <InquiryModal
        show={showInquiry}
        onClose={() => setShowInquiry(false)}
        inquiryData={inquiryData}
      />

    </div>
  );
};

export default CarHire;
